import Vue from 'vue';

Vue.component('v-radio-simple-button', require('./components/UI/VRadioSimpleButton').default);
Vue.component('language-switch', require('./components/LanguageSwitch').default);
Vue.component('v-radio-button', require('./components/UI/VRadioButton').default);
Vue.component('default-field', require('./components/UI/DefaultField').default);
Vue.component('v-multiselect', require('./components/UI/VMultiselect').default);
Vue.component('v-textarea', require('./components/UI/VTextarea').default);
Vue.component('v-checkbox', require('./components/UI/VCheckbox').default);
Vue.component('breadcrumbs', require('./components/Breadcrumbs').default);
Vue.component('paginator', require('./components/Paginator').default);
Vue.component('v-button', require('./components/UI/VButton').default);
Vue.component('v-label', require('./components/UI/VLabel').default);
Vue.component('v-input', require('./components/UI/VInput').default);
Vue.component('no-data', require('./components/NoData').default);
Vue.component('loader', require('./components/Loader').default);
Vue.component('modal', require('./components/Modal').default);
Vue.component('card', require('./components/Card').default);
